__turbopack_context__.v({
  "inlineEntitySelector": "InlineEntitySelector-module__3TffbG__inlineEntitySelector",
});
